var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('ext-slot',{attrs:{"name":"app.global"}}),_c('app-toast')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }